"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Box = _interopRequireDefault(require("../Box"));

var _Spacer = _interopRequireDefault(require("../Spacer"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _reactNative = require("react-native");

var _styledUtils = require("@sloth-system/styled-utils");

var _digiwashCore = require("digiwash-core");

var _CouponInputHelpers = require("./CouponInput-helpers");

var _ = require("..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CouponInput(props) {
  // States
  let [couponInput, setCouponInput] = (0, _react.useState)("");
  let [inputMode, setInputMode] = (0, _react.useState)("normal");
  let [errorMessage, setErrorMessage] = (0, _react.useState)(""); // Logic

  let canSubmitForm = !!couponInput && !props.loading;

  let onSubmit = () => {
    // Remove
    if (inputMode === "filled") {
      removeCodeWithConfirmation();
      return;
    } //  Add


    if (canSubmitForm) {
      if (props.onAdd) {
        props.onAdd(couponInput).catch(error => {
          setErrorMessage(error);
          setInputMode("error");
        });
      }
    }
  };

  let removeCodeWithConfirmation = () => {
    let question_text = "از حذف کد تخفیف اطمینان دارید؟";

    let removeCoupon = () => {
      if (props.onRemove) {
        props.onRemove().then(() => {
          setCouponInput("");
          setInputMode("normal");
        }).catch();
      }
    };

    if (_reactNative.Platform.OS === "web") {
      let confirmed = confirm(question_text);

      if (confirmed) {
        removeCoupon();
      }
    } else {
      _reactNative.Alert.alert("حذف کد تخفیف", question_text, [{
        text: "انصراف",
        style: "cancel"
      }, {
        text: "حذف",
        onPress: () => {
          removeCoupon();
        }
      }], {
        cancelable: false
      });
    }
  };

  let messages = [];

  if (props.reduction) {
    messages.push({
      type: "success",
      text: `مبلغ ${(0, _digiwashCore.formatPrice)(props.reduction)} تومان از سفارش شما کسر شد.`,
      color: "green.light900"
    });
  }

  if (errorMessage) {
    messages.push({
      type: "error",
      text: errorMessage,
      color: "red.main"
    });
  } // Hooks


  (0, _react.useEffect)(() => {
    if (props.code) {
      setInputMode("filled");
      setCouponInput(props.code);
    } else {
      setInputMode("normal");
      setCouponInput("");
    }
  }, [props.code]); // Values

  let {
    styles,
    content
  } = (0, _CouponInputHelpers.conditonal_values)(inputMode);
  let hasError = messages.length > 0 && !props.loading;
  let actionDisabled = !couponInput || props.loading; // Render

  if (props.switchGroupsIsLoading) {
    return /*#__PURE__*/_react.default.createElement(_reactNative.ActivityIndicator, {
      color: (0, _styledUtils.color)("primary.main")({
        theme: props.theme
      })
    });
  }

  if (props.workspaceName && !props.code) {
    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      bg: "red.light600",
      br: "xm",
      px: "l",
      py: "xm"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      distribution: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "red.dark"
    }, `این گروه کاربری فعال نیست`), props.prefix && /*#__PURE__*/_react.default.createElement(_Box.default, null, props.prefix)));
  }

  if (props.workspaceName) {
    return /*#__PURE__*/_react.default.createElement(_Box.default, {
      bg: "green.light500",
      br: "xm",
      px: "l",
      py: "xm"
    }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
      distribution: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "common.black"
    }, `کد تخفیف ${props.workspaceName} برای شما فعال شده است.`), props.prefix && /*#__PURE__*/_react.default.createElement(_Box.default, null, props.prefix)));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Input, {
    bg: styles.bg_input,
    p: styles.padding_input,
    onChangeText: text => {
      if (inputMode === "error") {
        setInputMode("normal");
        setErrorMessage("");
      }

      setCouponInput(text);

      if (props.onChange) {
        props.onChange();
      }
    },
    value: couponInput,
    placeholder: "\u06A9\u062F \u062A\u062E\u0641\u06CC\u0641 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
    onSubmit: onSubmit,
    disabled: inputMode === "filled",
    action: /*#__PURE__*/_react.default.createElement(_Button.default, {
      onPress: onSubmit,
      prefix: props.loading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
        size: "m"
      }), /*#__PURE__*/_react.default.createElement(_reactNative.ActivityIndicator, {
        color: (0, _styledUtils.color)(styles.action_button_loading)({
          theme: props.theme
        })
      }), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
        size: "m"
      })),
      fill: styles.action_button,
      textColor: styles.action_button_text,
      disabled: actionDisabled
    }, content.action_button),
    onFocus: () => {
      if (props.onFocus) {
        props.onFocus();
      }
    },
    onBlur: () => {
      if (props.onBlur) {
        props.onBlur();
      }
    },
    prefix: props.prefix
  }), hasError && props.errorRenderer ? props.errorRenderer(messages) : undefined);
}

var _default = CouponInput;
exports.default = _default;